import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css'; 
import logo from '../assets/logo192.png';

const Navbar = () => {
  return (
    <nav className="navbar">
      <p className="navbar-logo">
        <Link to="/">
          <img src={logo} alt="FaceLead Logo" /> 
          <span className="navbar-text">FaceLead</span>
        </Link>
      </p>
      <ul className="nav-links">
        <li>
            <Link to="/blinks">Blinks</Link>
        </li>
        <li>
            <Link to="/docs/introduction">Docs</Link>
        </li>
        <li>
          <Link to="/download">Download</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
